import axios from "axios";
// import API_URLS from './backendConfig';

const axiosInstance = axios.create({});

const axiosInstance1 = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
});

export const postRequest = async ({ url, data, headers }) => {
  try {
    const response = await axiosInstance.post(url, data, {
      headers: headers || {},
      withCredentials: true,
    });
    return response.data;
  } catch (error) {
    return handleRequestError(error);
  }
};
export const getRequest = async ({ url, headers, params }) => {
  try {
    const response = await axiosInstance.get(url, {
      headers: headers || {},
      params,
      withCredentials: true,
    });

    return response.data;
  } catch (error) {
    return handleRequestError(error);
  }
};

export const putRequest = async ({ url, data, headers }) => {
  try {
    const response = await axiosInstance.put(url, data, {
      headers: headers || {},
      withCredentials: true,
    });
    return response.data;
  } catch (error) {
    return handleRequestError(error);
  }
};

export const patchRequest = async ({ url, data, headers }) => {
  try {
    const response = await axiosInstance.patch(url, data, {
      headers: headers || {},
      withCredentials: true,
    });
    return response.data;
  } catch (error) {
    return handleRequestError(error);
  }
};

export const deleteRequest = async ({ url, headers }) => {
  try {
    const response = await axiosInstance.delete(url, {
      headers: headers || {},
      withCredentials: true
    });
    return response.data;
  } catch (error) {
    return handleRequestError(error);
  }
};

const handleRequestError = (error) => {
  if (error.response) {
    return {
      success: false,
      status: error.response.status,
      data: error.response.data,
    };
  } else if (error.request) {
    return {
      success: false,
      status: null,
      data: { message: "No response received from server" },
    };
  } else {
    return {
      success: false,
      status: null,
      data: { message: error.message },
    };
  }
};

export const postRequestFile = async ({ url, data, headers = {} }) => {
  try {
    const response = await axiosInstance1.post(url, data, {
      headers: {
        ...headers,
      },
      withCredentials: true,
    });
    return response.data;
  } catch (error) {
    return handleRequestError(error);
  }
};

export const putRequestFile = async ({ url, data, headers }) => {
  try {
    const response = await axiosInstance.put(url, data, {
      headers: {
        ...headers,
      },
      withCredentials: true,
    });
    return response.data;
  } catch (error) {
    return handleRequestError(error);
  }
};
